/**
 * @deprecated Do not use this file in the new code base. Use api files from `modules/connect` instead.
 */

import axios, { AxiosRequestConfig } from "axios";

import { getErrorDetails } from "api/helpers/getErrorDetails";
import { PaginatedList } from "api/helpers/pagination";
import { DEFAULT_PAGINATION } from "constants/defaultPagination";

import type {
  CashManagementProvider,
  CashManagementProviderCurrencies,
} from "../models/Provider";

export type GetCashManagementsProviders = (
  options?: AxiosRequestConfig
) => Promise<PaginatedList<CashManagementProvider>>;

export type GetSupportedCurrencies = (
  options?: AxiosRequestConfig
) => Promise<CashManagementProviderCurrencies>;

export const getSupportedCurrencies: GetSupportedCurrencies = async (
  options
) => {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: "/cash-management/currencies",
      params: DEFAULT_PAGINATION,
    });
    const { data = {} } = response;

    return data;
  } catch (error) {
    throw getErrorDetails(error);
  }
};
